import type { PaymentReceipt } from 'types/paymentReceipt'

export interface PaymentOutput {
    address: string
    amountInSats: number
    mentionedUser: string
}

export interface ComposerPaymentIntent {
    paymentId: string
    payments: PaymentOutput[]
    receipt?: PaymentReceipt
}

// Keep the same business intent through an uncertain send response or a failed post.
// A changed destination/amount, or a new draft, always gets a different payment ID.
export function getComposerPaymentIntent(
    intents: Map<string, ComposerPaymentIntent>,
    draftId: string,
    payments: PaymentOutput[],
    createId: () => string,
): ComposerPaymentIntent {
    const key = JSON.stringify([
        draftId,
        payments
            .map(({ address, amountInSats, mentionedUser }) => [
                address,
                amountInSats,
                mentionedUser,
            ])
            .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right))),
    ])
    let intent = intents.get(key)
    if (!intent) {
        intent = { paymentId: createId(), payments: payments.map(payment => ({ ...payment })) }
        intents.set(key, intent)
    }
    return intent
}

export function restoreComposerPaymentIntents(
    saved: Array<[string, ComposerPaymentIntent]> | undefined,
): Map<string, ComposerPaymentIntent> {
    return new Map(saved || [])
}
